import { useMutation } from 'react-query'

import { uploadReel } from 'services/endpoints/post'

export function useUploadReelMutation() {
  return useMutation(async (payload: any) => {
    return await uploadReel({
      ...payload,
      discovery: true,
      show_feed: true
    })
  })
}